import React from "react";
import { Card } from "antd";
import { Link } from "react-router-dom";

const  Meta  = Card.Meta;

const CardComponent = ({ title, description, link, image, heightTest=250 }) => {
  return (
    <Link to={link}>
      <Card hoverable
       style={{
      width: 250,
      height: heightTest,
      borderRadius:'12px 12px 8px 8px',
    }}
    cover={
      <img
        alt={description}
        src={image}
      />
    }
      >
      <Meta title={title} description={description} />
      </Card>
    </Link>
  );
};

export default CardComponent;
